import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, Divider, ListItemText, ListItemAvatar, Avatar, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
	},
	inline: {
		display: "inline",
	},
	PCLStatus: {
		display: "inline",
		marginInlineEnd: "20px",
		[theme.breakpoints.down("sm")]: {
			marginInlineEnd: "10px",
		},
		[theme.breakpoints.down("xs")]: {
			display: "block",
			marginInlineEnd: "0px",
		},
	},
}));

export default function PreviousCommentsLists(props) {
	const classes = useStyles();

	return (
		<List className={classes.root}>
			<ListItem alignItems="flex-start">
				<ListItemAvatar>
					<Avatar />
				</ListItemAvatar>
				<ListItemText
					primary={props.name}
					secondary={
						<React.Fragment>
							<div>
								<Typography variant="caption">{props.time}</Typography>
							</div>
							<Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
								{props.comment}
							</Typography>
							<div>
								<div className={classes.PCLStatus}>
									<Typography variant="body2" display="inline" color="primary">
										Disposition :
									</Typography>
									<Typography variant="body2" display="inline">
										{" "}
										{props.disposition}
									</Typography>
								</div>
								<div className={classes.PCLStatus}>
									<Typography variant="body2" display="inline" color="primary">
										Sub Disposition :
									</Typography>
									<Typography variant="body2" display="inline">
										{" "}
										{props.subdisposition}
									</Typography>
								</div>
								<div className={classes.PCLStatus}>
									<Typography variant="body2" display="inline" color="primary">
										Call Status :
									</Typography>
									<Typography variant="body2" display="inline">
										{" "}
										{props.status}
									</Typography>
								</div>
							</div>
						</React.Fragment>
					}
				/>
			</ListItem>
			<Divider variant="inset" component="li" />
		</List>
	);
}
